import { render, staticRenderFns } from "./SvgCultureCategory.vue?vue&type=template&id=2764b70c&scoped=true"
import script from "./SvgCultureCategory.vue?vue&type=script&lang=js"
export * from "./SvgCultureCategory.vue?vue&type=script&lang=js"
import style0 from "./SvgCultureCategory.vue?vue&type=style&index=0&id=2764b70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764b70c",
  null
  
)

export default component.exports